import {
    FETCH_LOGIN_FULFILLED,
    FETCH_LOGIN_REJECTED,
    FETCH_LOGIN_PENDING,
    FETCH_TFA_PENDING,
    FETCH_TFA_FULFILLED,
    FETCH_TFA_REJECTED,
    LOGOUT,
} from "../../actions/auth/login";

const token = localStorage.getItem("accessToken");

const initialState = token
    ? {
        done: false,
        error: null,
        spinner: false,
        isLogin: true,
        isTfaNeeded: false,
    }
    : {
        done: false,
        error: null,
        spinner: false,
        isLogin: false,
        isTfaNeeded: false,
    };

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LOGIN_PENDING:
            return {
                ...state,
                done: false,
                error: null, // Clear previous errors
                spinner: true,
                isLogin: false,
                isTfaNeeded: false, // Reset TFA requirement on a new login attempt
            };
        case FETCH_LOGIN_FULFILLED:
            localStorage.setItem("accessToken", action.payload.accessToken);
            localStorage.setItem("refreshToken", action.payload.refreshToken);
            localStorage.setItem("user", JSON.stringify(action.payload.user));
            localStorage.setItem("IsDoctor", JSON.stringify(action.payload.user.isDoctor));

            return {
                ...state,
                login: action.payload,
                done: true,
                error: null,
                spinner: false,
                isLogin: !action.payload.isTfaNeeded, // User is not logged in fully if TFA is required
                isTfaNeeded: action.payload.isTfaNeeded || false, // Explicitly set isTfaNeeded
            };
        case FETCH_LOGIN_REJECTED:
            return {
                ...state,
                error: action.payload || "Login failed", // Provide a default error message
                done: false,
                spinner: false,
                isLogin: false,
                isTfaNeeded: false, // Reset TFA requirement on login failure
            };
        case FETCH_TFA_PENDING:
            return {
                ...state,
                spinner: true,
                error: null, // Clear previous errors
            };
        case FETCH_TFA_FULFILLED:
            localStorage.setItem("accessToken", action.payload.accessToken);
            localStorage.setItem("refreshToken", action.payload.refreshToken);
            localStorage.setItem("user", JSON.stringify(action.payload.user));
            localStorage.setItem("IsDoctor", JSON.stringify(action.payload.user.isDoctor));

            return {
                ...state,
                done: true,
                spinner: false,
                isLogin: true, // User is fully logged in after successful TFA
                isTfaNeeded: false, // Reset TFA requirement
            };
        case FETCH_TFA_REJECTED:
            return {
                ...state,
                error: action.payload || "TFA verification failed", // Provide a default error message
                spinner: false,
            };
        case LOGOUT:
            localStorage.clear(); // Ensure all relevant storage is cleared
            return {
                ...initialState, // Reset to initial state
                isLogin: false,
            };
        default:
            return state;
    }
};
